/*** 
PC_TD_01
importing the API getEmployeeDetails function from DirecorAPI
and also importing the addfeedback function from AddFeedbackForm component
***/
import { useState, useEffect } from 'react';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import React from 'react';
import { Tooltip } from 'antd';
import {
    getEmployeeDetails,
    getDomain,
    getCTC,
    getStatus,
    getGroup,
    getEmployeeDetailsForDashboard,
    getReportingEmpId,
} from '../service/DirectorAPI';
import moment, { months } from 'moment';
import AddFeedback from './AddFeedbackForm';
import '../components/custom';
import '../components/edcss/Toast.css';
import ReactTooltip from 'react-tooltip';
import Loader from '../StaticComponent/Loader';
import BreadCrumbs from '../components/BreadCrumbs/BreadCrumbs.jsx';
import DOMPurify from 'dompurify';
import { useLocation, useNavigate } from 'react-router-dom';
import { encryptStorage } from '../constant';
import '../components/edcss/Team-DirectoryGrid.css';

/**
 * PC_TD_03 create a TeamDirectory() function and it return the HTML
 *
 */
function TeamDirectory() {
    const dashboard = useLocation();

    /***
     * PC_TD_02
     * Declaring state variables and array
     ***/
    let GridLoadarray = [];
    const [gridData, setGridData] = useState(GridLoadarray);
    const [searchValue, setSearchValue] = useState('');
    const [columnOrder, setColumnOrder] = useState('ASC');
    const [columnName, setColumnName] = useState('emp_name');
    const [sorthide, setsorthide] = useState('emp_name@ASC');
    const [dataLength, setdataLength] = useState();
    const [hideFilterPopUp, sethideFilterPopUp] = useState(true);
    const [countPerPage, setCoutPerPage] = useState(10);
    let dropDownArraydomain = [];
    const [arrDropDowndomain, setarrDropDowndomain] = useState(dropDownArraydomain);
    let dropDownArrayCTC = [];
    const [arrDropDownctc, setarrDropDownctc] = useState(dropDownArrayCTC);
    let dropDownArrayStatus = [];
    const [arrDropDownstatus, setarrDropDownstatus] = useState(dropDownArrayStatus);
    let dropDownArrayGroup = [];
    const [arrDropDowngroup, setarrDropDowngroup] = useState(dropDownArrayGroup);
    const [reportingEmpIds, setReportingEmpIds] = useState([]);
    const [isLoading, setIsLoading] = React.useState(true);
    const [hideToast, setHideToast] = useState(true);
    const [isFromDashboard, setIsFromDashboard] = useState(false);
    let [hideFeedbackForm, setHideFeedbackForm] = useState(true);
    const [popup, setpopup] = useState(false);
    const [kebaboption, setkebaboption] = useState(false);
    const [option,setoption] = useState("");
    const [totalCount, setTotalCount] = useState(0);
    //PC_TS_01 -> servicePeriod is declared
    // const [servicePeriod, setServicePeriod] = useState("");
    let servicePeriod = '';

    let filter = {
        domain: '',
        status: '',
        ctc: '',
        grandRating: '',
        startDate: '',
        endDate: '',
    };
    const [filterData, setFilterData] = useState(filter);
    let [empId, setEmpId] = useState();
    let [empName, setEmpName] = useState();
    let [empDomain, setEmpDomain] = useState();

    let search = window.location.search;
    let params = new URLSearchParams(search);
    // let emp_id = params.get('EmpId');
   let emp_id = (params.get('EmpId') === null || params.get('EmpId') === undefined) ? '' : params.get('EmpId');
    let isDashboard = params.get('dashboard');
    let login_id = encryptStorage.getItem('employeeId');
    let role = encryptStorage.getItem('role');
    let CurrentEvaluationId = encryptStorage.getItem('CurrentEvaluationId');
    let PreviousEvaluationId = encryptStorage.getItem('PreviousEvaluationId');

    let breadCrumbsData = role == "Admin" ? [{ title: 'Dashboard', isActive: true, path: '/Overview' },
    { title: 'Admin', isActive: true, path: '/admin' },
    { title: 'Team Member', isActive: true, path: '' },
    { title: 'Team Directory', isActive: false, path: '/FeedbackGrid' },
    ]
        : [
            { title: 'Dashboard', isActive: true, path: '/Overview' },
            { title: 'Team Member', isActive: true, path: '' },
            { title: 'Team Directory', isActive: false, path: '/TeamDirectory' },
        ];
    const navigate = useNavigate();
    /**
     * PC_TD_03 loadTeamDirectoryGridPage function is called inside
     *  the useEffect to get the data from Database
     */

    useEffect(() => {
        if (isDashboard != 'true') {
            window.history.pushState(
                { ...dashboard.state, ['flag']: '', ['end_date']: '', ['start_date']: '', ['rating']: '', ['range']: '', ['domain']: '' },
                'Title'
            );
        }
        if (encryptStorage.getItem('groupid') == 1 || encryptStorage.getItem('groupid') == 2) {
            LoadReportingEmpIds();
            loadTeamDirectoryGridPage();
            LoadDomain();
            LoadCtc();
            LoadStatus();
            LoadGroup();
        } else {
            navigate('/', { state: { hideNav: false } });
        }
    }, [countPerPage, columnOrder, columnName]);

    useEffect(() => {
        setTimeout(() => {
            setHideToast(true);
        }, 2500);
    }, [hideToast]);
    /***
     * PC_TD_03.2
     * this function invock the getDomain api call
     */
    const LoadDomain = async () => {
        let domainData = {};
        let responsedata = await getDomain(domainData);
        if (responsedata?.data != undefined && responsedata?.data != null && responsedata?.data?.ResponseData[0]?.length != 0) {
            setarrDropDowndomain(responsedata?.data.ResponseData[0]);
        }
    };

    /***
     * PC_TD_03.3
     * this function invock the getCTC api call
     */
    const LoadCtc = async () => {
        let ctcData = {};
        let responsedata = await getCTC(ctcData);
        if (responsedata?.data != undefined && responsedata?.data != null && responsedata?.data?.ResponseData[0]?.length != 0) {
            setarrDropDownctc(responsedata?.data.ResponseData[0]);
        }
    };

    /***
     * PC_TD_03.4
     * this function invock the getStatus api call
     */
    const LoadStatus = async () => {
        let statusData = {};
        let responsedata = await getStatus(statusData);
        if (responsedata?.data != undefined && responsedata?.data != null && responsedata?.data.ResponseData[0].length != 0) {
            setarrDropDownstatus(responsedata?.data.ResponseData[0]);
        }
    };

    /***
     * PC_TD_03.5
     * this function invock the getGroup api call
     */
    const LoadGroup = async () => {
        let groupData = {};
        let responsedata = await getGroup(groupData);
        if (responsedata?.data != undefined && responsedata?.data != null && responsedata?.data?.ResponseData[0]?.length != 0) {
            setarrDropDowngroup(responsedata?.data.ResponseData[0]);
        }
    };
    /**
     * PC_TD_03.5.1 this function get the reporting employee id
     */
    const LoadReportingEmpIds = async () => {
        let loginEmpData = { login_id: login_id };
        let responsedata = await getReportingEmpId(loginEmpData);
        if (responsedata?.data != undefined && responsedata?.data != null && responsedata?.data?.ResponseData[0]?.length != 0) {
            setReportingEmpIds(responsedata?.data.ResponseData[0]);
        }
    };

    /***
     * PC_TD_10.1
     * this function map and return the value
     */
    const buildDomain = () => {
        return arrDropDowndomain.map((value, index) => {
            return <option value={value.domain}>{value.domain}</option>;
        });
    };

    /**
     * PC_TD_10.2
     * this function map and bind the values into the dropdown optioin field
     */
    const buildCtc = () => {
        return arrDropDownctc.map((value, index) => {
            return <option value={value.ctc}>{value.ctc}</option>;
        });
    };

    /**
     * PC_TD_10.3
     * this function map and bind the values into the dropdown optioin field
     */
    const buildStatus = () => {
        return arrDropDownstatus.map((value, index) => {
            return <option value={value.name}>{value.name}</option>;
        });
    };

    /**
     * PC_TD_10.4
     * this function map and bind the values into the dropdown optioin field
     */
    const buildGroup = () => {
        return arrDropDowngroup.map((value, index) => {
            return <option value={value.group}>{value.group}</option>;
        });
    };
    /**
     * PC_TD_03.1,PC_04 loadTeamDirectoryGridPage function get the team directory details
     * and the role and login_id is getting from session storage
     */
    const loadTeamDirectoryGridPage = async (filter = {}) => {
        if (filter?.domain === undefined) {
            filter = filterData;
        }

        setIsLoading(false);
        setEmpId(emp_id);
        sethideFilterPopUp(true);

        if (dashboard.state) {
            //dashboard.state

            // if user click any card from bashboard this eill execute

            let salary_range = dashboard?.state?.range?.slice(0, '-4');
            let simplifiedRange;
            if (salary_range) {
                let [start, end] = salary_range?.split('-');
                simplifiedRange = `${start}.1-${end}`;
            }

            setIsFromDashboard(true);
            let empdata = {
                emp_id: emp_id,
                reports_to: login_id,
                role: role,
                dashboard_domain: dashboard?.state?.domain || '',
                dashboard_start_date: dashboard?.state?.start_date || '',
                dashboard_end_date: dashboard?.state?.end_date || '',
                salary_range: simplifiedRange || '',
                dashboard_rating: dashboard?.state?.rating || '',
                dashboard_flag: dashboard?.state?.flag || '',
                PageSize: countPerPage,
                CurrentEvaluationId: CurrentEvaluationId,
                PreviousEvaluationId: PreviousEvaluationId,
                sortOrder: columnOrder,
                sortColumn: columnName,
                searchData: searchValue,
                domain: filter.domain,
                status: filter.status,
                ctc: filter.ctc,
                grand_rating: filter.grandRating,
                end_date: filter.endDate,
                start_date: filter.startDate,
            };

            try {
                let data = await getEmployeeDetailsForDashboard(empdata);
                setGridData(data?.data?.ResponseData[0]);
                setdataLength(data?.data?.ResponseData[0]?.length);

                if (data.data.Success === true) {
                    setIsLoading(true);
                }
            } catch (e) {
                throw e;
            }
        } else {
            let empdata = {
                emp_id: emp_id,
                reports_to: login_id,
                role: role,
                CurrentEvaluationId: CurrentEvaluationId,
                PreviousEvaluationId: PreviousEvaluationId,
                searchData: searchValue,
                sortOrder: columnOrder,
                sortColumn: columnName,
                PageSize: countPerPage,
                domain: filter.domain,
                status: filter.status,
                ctc: filter.ctc,
                grand_rating: filter.grandRating,
                end_date: filter.endDate,
                start_date: filter.startDate,
            };

            try {
                let data = await getEmployeeDetails(empdata);

                setGridData(data?.data?.ResponseData[0]);
                setdataLength(data?.data?.ResponseData[1]);
                setTotalCount(data?.data?.TotalCount);

                if (data?.data?.Success === true) {
                    setIsLoading(true);
                }
            } catch (e) {
                throw e;
            }
        }
    };
    /***
     * PC_TD_31
     * this function set the user enter valus into the variable
     */
    const OnChangeName = (e) => {
        setFilterData({ ...filterData, [e.target.name]: e.target.value });
    };
    /***
     * PC_TD_31
     * this function show and hide the filter popup
     */
    const filterClicked = async () => {
        try {
            sethideFilterPopUp(hideFilterPopUp == true ? false : true);
        } catch (e) { }
    };
    /***
     * PC_TD_39
     * this function clear the all filter values and call the loadTeamDirectoryGridPage function
     */
    const filterClearClicked = () => {
        let filter = {
            domain: '',
            status: '',
            ctc: '',
            grandRating: '',
            startDate: '',
            endDate: '',
        };
        filterClicked();
        setFilterData(filter);
        loadTeamDirectoryGridPage(filter);
    };
    //PC_TS_09 -> isDateInRange() is defined
    function isDateInRange(joinDate, startDate, endDate) {
        startDate = moment(new Date(startDate)).format('YYYY-MM-DD');
        endDate = moment(new Date(endDate)).format('YYYY-MM-DD');
        joinDate = moment(new Date(joinDate)).format('YYYY-MM-DD');

        return joinDate >= startDate && joinDate <= endDate;
    }
    //PC_TS_10 -> servicePeriodDifference() is defined
    function servicePeriodDifference(currentDate, joinDate) {
        currentDate = moment(new Date(currentDate)).format('YYYY-MM-DD');
        joinDate = moment(new Date(joinDate)).format('YYYY-MM-DD');
        let current = new Date(currentDate);
        let joined = new Date(joinDate);
        let timeDifference = current - joined;
        let daysDifference = timeDifference / (1000 * 60 * 60 * 24);
        let monthsDifference = Math.floor(daysDifference / 30.44);
        return monthsDifference;
    }
    function monthsYearConversion(months) {
        const year = Math.floor(months / 12);
        const month = months % 12;
        return { year, month };
    }
    function nameSubstring(value) {
        var tipCount;
        if (value?.length > 21) {
            let data = value?.substring(0, 21);
            data = data + '...';
            tipCount = 1;
            return data;
        } else {
            let data = value;
            tipCount = 0;
            return data;
        }
    }
    /***
     * PC_TD_10 PC_TS_03 this function map the and return the values
     */
    const teamDirectoryBodyData = () => {
        try {
            if (gridData.length == 0) {
                return (
                    <tr>
                        <td colspan="10" className="accord-content1">
                            <div className="row justify-content-center">
                                <img
                                    src="/Images/nodatafound.png"
                                    alt="nodatafound"
                                    className="nofeedbackimg-sty"
                                    style={{ height: '500px', width: '750px' }}
                                />
                                <h2 className="tt-bold font-15 text-center margin-negative">No Records Found</h2>
                            </div>
                        </td>
                    </tr>
                );
            } else {
                return gridData.map((obj, index) => {
                    // let m = moment(new Date(obj.joined_date));
                    let joinDate = obj.joined_date ? moment(new Date(obj.joined_date)).format('MMM DD, YYYY') : '';
                    // let lastRevisionDate = moment(new Date(obj.last_revision_date)).format('MMM DD,YYYY');
                    let lastRevisionDate =  moment.utc(obj.last_revision_date).format('MMM DD, YYYY') 
                    const phoneNoLink = `tel:${obj.phone_num}`; 
                    const emailLink = `mailto:${obj.email_id}`;
                    let month =  obj.month;

                    var empCharName = nameSubstring(obj.emp_name);
                    var empCharRole = nameSubstring(obj.role);
                    // //PC_TS_04 -> currentDate,startDate,endDate are declared
                    let currentDate = moment(Date()).format('MMM DD,YYYY');
                    // let startDate;
                    // let endDate;
                    //PC_TS_05 -> condition for BDE is checked
                    if (obj.domain == 'Business Development Executive' && obj.status == 'Active') {
                        if (isDateInRange(joinDate, 'Jan 01, 2022', 'May 01, 2023')) {
                            // setServicePeriod("SLA Met")
                            let result = 'SLA Met';
                            servicePeriod = result;
                        } else if (isDateInRange(joinDate, 'Jun 2023', currentDate)) {
                            let result = servicePeriodDifference(currentDate, joinDate);
                            if (result > 14) {
                                servicePeriod = 'SLA Met';
                            } else {
                                servicePeriod = Math.abs(result - 14);
                                const { year, month } = monthsYearConversion(servicePeriod);
                                year != 0 ? (servicePeriod = `${year} Year ${month} Months`) : (servicePeriod = `${month} Months `);
                            }
                        }
                    }
                    //PC_TS_06 -> condition for BEA is checked
                    else if (obj.domain == 'BEA' && obj.status == 'Active') {
                        if (isDateInRange(joinDate, 'Dec 01, 2019', 'Dec 01, 2022')) {
                            let result = servicePeriodDifference(currentDate, joinDate);
                            if (result > 27) {
                                servicePeriod = 'SLA Met';
                            } else {
                                servicePeriod = Math.abs(result - 27);
                                const { year, month } = monthsYearConversion(servicePeriod);
                                year != 0 ? (servicePeriod = `${year} Year ${month} Months`) : (servicePeriod = `${month} Months `);
                            }
                        } else if (isDateInRange(joinDate, 'Jan 01, 2023', currentDate)) {
                            let result = servicePeriodDifference(currentDate, joinDate);
                            if (result > 30) {
                                servicePeriod = 'SLA Met';
                            } else {
                                servicePeriod = Math.abs(result - 30);
                                const { year, month } = monthsYearConversion(servicePeriod);
                                year != 0 ? (servicePeriod = `${year} Year ${month} Months`) : (servicePeriod = `${month} Months `);
                            }
                        }
                    }
                    //PC_TS_07 -> condition for HR is checked
                    else if (obj.domain == 'Human Resource' && obj.status == 'Active') {
                        if (joinDate < 'Jan 01, 2019') {
                            let result = servicePeriodDifference(currentDate, joinDate);
                            if (result > 38) {
                                servicePeriod = 'SLA Met';
                            } else {
                                servicePeriod = Math.abs(result - 26);
                                const { year, month } = monthsYearConversion(servicePeriod);
                                year != 0 ? (servicePeriod = `${year} Year ${month} Months`) : (servicePeriod = `${month} Months `);
                            }
                        } else if (isDateInRange(joinDate, 'Jan 01, 2020', currentDate)) {
                            let result = servicePeriodDifference(currentDate, joinDate);
                            if (result > 26) {
                                servicePeriod = 'SLA Met';
                            } else {
                                servicePeriod = Math.abs(result - 38);
                                const { year, month } = monthsYearConversion(servicePeriod);
                                year != 0 ? (servicePeriod = `${year} Year ${month} Months`) : (servicePeriod = `${month} Months `);
                            }
                        }
                    }
                    //PC_TS_08 -> else
                    else {
                        if (obj.status == 'Active') {
                            if (isDateInRange(joinDate, 'Dec 01, 2019', currentDate)) {
                                let result = servicePeriodDifference(currentDate, joinDate);
                                if (result > 30) {
                                    servicePeriod = 'SLA Met';
                                } else {
                                    servicePeriod = Math.abs(result - 30);
                                    const { year, month } = monthsYearConversion(servicePeriod);
                                    year != 0 ? (servicePeriod = `${year} Year ${month} Months`) : (servicePeriod = `${month} Months `);
                                }
                                // servicePeriod = result - 30;
                            } else {
                                servicePeriod = 'SLA Met';
                            }
                        }
                    }
                    if (obj.status == 'Inactive') {
                        servicePeriod = 'NIL';
                    }

                    return (
                        <tr className="hive-table-data regular-text align-middle">
                            <td className=" profile-det-popover curser-pointer">
                                <div className="d-flex align-items-center">
                                    <a href={`/profilecontainer?EmpId=${obj.emp_id}&Status=${obj.status}`}>
                                        <img
                                            src={DOMPurify.sanitize(obj.profile_img_url) ? DOMPurify.sanitize(obj.profile_img_url) : '/Images/logo-person-user-person-icon.jpg'}
                                            className="table-image"
                                        />
                                    </a>
                                    <div className="ms-2">
                                        <a
                                            href={`/profilecontainer?EmpId=${obj.emp_id}&Status=${obj.status}`}
                                            className="directory-name-style mb-0 d-flex align-items-center semibold-text "
                                        >
                                            {obj.emp_name ? empCharName : '-'}
                                            {obj.status == 'Inactive' ? (
                                                <>
                                                    <span>
                                                        <img
                                                            src="Images/inactive-batch.svg"
                                                            alt="inactive-batch"
                                                            className="ms-2 inact-bat-img"
                                                        />
                                                    </span>
                                                    <span className="font-9 inactive-txt-clr ms-1">Inactive</span>
                                                </>
                                            ) : (
                                                <></>
                                            )}
                                        </a>
                                        <p className="directory-domain-style mb-0">{obj.role ? empCharRole : '-'}</p>
                                    </div>
                                </div>
                                <div className="prof-det-crd shadow">
                                    <div className="row">
                                        <div className="d-flex align-item-center mb-4">
                                            <div className="d-block">
                                                <img
                                                    src={
                                                        obj.profile_img_url
                                                            ? obj.profile_img_url
                                                            : '/Images/logo-person-user-person-icon.jpg'
                                                    }
                                                    className="emp-prof-popover"
                                                />
                                            </div>
                                            <div className="d-block ms-3">
                                                <h3 className="mb-1 font-17 bold-text">{obj.emp_name}</h3>
                                                <p className="mb-0 font-12 regular-text">{obj.role}</p>
                                                <p className="mb-0 font-12 regular-text">{obj.domain}</p>
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <span className="d-block mb-2 font-14">
                                                <span>
                                                    <img src="Images/hive-mail-icon.svg" alt="hive-mail-icon" />
                                                </span>
                                                <a href={DOMPurify.sanitize(emailLink)} className="prof-link regular-text ms-3">
                                                    <span>{obj.email_id ? obj.email_id : '-'}</span>
                                                </a>
                                            </span>
                                            <span className="d-block mb-2 font-14">
                                                <span>
                                                    <img src="Images/hive-phn-icon.svg" alt="hive-phn-icon" />
                                                </span>
                                                <a href={DOMPurify.sanitize(phoneNoLink)} className="prof-link regular-text ms-3">
                                                    <span>{obj.phone_num ? obj.phone_num : '-'}</span>
                                                </a>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </td>

                            <td>
                                <div className="d-flex text-start">
                                    {obj.grand_rating ? (
                                        <>
                                            <img
                                                src={
                                                    !obj.grand_rating
                                                        ? null
                                                        : obj.grand_rating.includes('+')
                                                            ? `/Images/${obj.grand_rating?.slice(0, -1)}_plus.png`
                                                            : obj.grand_rating.includes('-')
                                                                ? `/Images/${obj.grand_rating?.slice(0, -1)}_minus.png`
                                                                : null
                                                }
                                                alt="A+"
                                                className="td-rating-emoj"
                                            />
                                            <span className="ms-2 tt-bold font-18 font-blue">{obj.grand_rating}</span>
                                        </>
                                    ) : (
                                        <span className="ms-2 tt-bold font-18 font-blue">NIL</span>
                                    )}
                                </div>
                            </td>
                            {/* {role !== 'Manager' ? <td>{obj.domain ? obj.domain : '-'}</td> : null} */}
                            {/* <td>{obj.status ? obj.status : '-'}</td> */}
                            {/* <td>{obj.email_id ? obj.email_id : '-'}</td> */}
                            <td className="text-end hive-td-ctc">{obj.ctc ? obj.ctc : '-'}</td>
                            <td>{obj.last_revision_date ? lastRevisionDate : '-'}
                                <p class="custom-table-tooltip font-12 ">{obj.month ? month : '0'} months 
                                <Tooltip title="Months since last revision" class="custom-table-tooltip font-12">
                                <img class="ms-1" src="/Images/tool-tip-icon.svg" alt="tooltip-icon"/> </Tooltip></p>
                            </td>
                            <td>{joinDate ? joinDate : '-'}</td>
                            <td>{servicePeriod}</td>
                            <td>
                                <a href={phoneNoLink} className={obj.phone_num ? 'directory-phn' : 'directory-phn directory-phn-null'}>
                                    {obj.phone_num ? obj.phone_num : '-'}
                                </a>
                            </td>
                            <td className="text-center">
                                <span className="me-3">
                                    <ReactTooltip />
                                    {/* PC_12.3 redirected to infivigualFeedbackGrid component with necessary values in query string*/}
                                    <a
                                        href={`/indivigualfeedbackgrid?EmpId=${obj.emp_id}&Flag=G&emp_name=${obj.emp_name}&emp_domain=${obj.domain}&Status=${obj.status}`}
                                    >
                                        <img
                                            src="/Images/Green-Flag.svg"
                                            alt="green-flag"
                                            data-bs-toggle="tooltip"
                                            data-place="bottom"
                                            data-className="tooltip-padding"
                                            data-bs-placement="bottom"
                                            data-tip={'green flag'}
                                        />
                                    </a>
                                    <span className="ms-2">{obj.green_flag ? obj.green_flag : 0}</span>
                                </span>
                                <span className="me-3">
                                    <ReactTooltip />
                                    {/* PC_12.3 redirected to infivigualFeedbackGrid component with necessary values in query string*/}
                                    <a
                                        href={`/indivigualfeedbackgrid?EmpId=${obj.emp_id}&Flag=Y&emp_name=${obj.emp_name}&emp_domain=${obj.domain}&Status=${obj.status}`}
                                    >
                                        <img
                                            src="/Images/Yellow-Flag.svg"
                                            alt="yellow-flag"
                                            data-bs-toggle="tooltip"
                                            data-className="tooltip-padding"
                                            data-bs-placement="bottom"
                                            data-place="bottom"
                                            data-tip={'yellow flag'}
                                        />
                                    </a>
                                    <span className="ms-2">{obj.yellow_flag ? obj.yellow_flag : 0}</span>
                                </span>
                                <span>
                                    <ReactTooltip />
                                    {/* PC_TD_12.3 redirected to infivigualFeedbackGrid component with necessary values in query string*/}
                                    <a
                                        href={`/indivigualfeedbackgrid?EmpId=${obj.emp_id}&Flag=R&emp_name=${obj.emp_name}&emp_domain=${obj.domain}&Status=${obj.status}`}
                                    >
                                        <img
                                            src="/Images/red-flag.svg"
                                            alt="red-flag"
                                            data-effect="solid"
                                            data-className="tooltip-padding"
                                            data-bs-toggle="tooltip"
                                            data-place="bottom"
                                            data-bs-placement="bottom"
                                            data-tip={'red flag'}
                                        />
                                    </a>
                                    <span className="ms-2">{obj.red_flag ? obj.red_flag : 0}</span>
                                </span>
                            </td>
                            <td>
                                <div class="dropdown">
                                    <button class="btn align-top shadow-none" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                        <img src="/Images/kebab-menu.svg" alt='kebab-icon' />
                                    </button>

                                    <ul className="dropdown-menu shadow border-0">
                                        {/* PC_TD_11 here validation the role and emp_id is present in the reportingEmpIds array  */}
                                        {role != 'Hr' && reportingEmpIds.some((emp) => emp.emp_id == obj.emp_id) ? (
                                            <li>
                                                {/* PC_TD_12 feedback necessary values are set in to the variables */}
                                                <a
                                                    className="dropdown-item  semibold-text border-bottom py-2 font-12 directory-feedback"
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => FeedbackClicked(obj.emp_id, obj.emp_name, obj.domain)}
                                                // data-bs-toggle="modal"
                                                // data-bs-target="#AddFeedbackDetailsPopup"
                                                >
                                                    Add Feedback
                                                </a>
                                            </li>
                                        ) : null}
                                        <li>
                                            {/* PC_TD_12.1 offboarding form redirection is happen with necessary values */}
                                            <a
                                                className="dropdown-item  semibold-text directory-offboarding py-2 font-12"
                                                href={`/offboardingForm?emp_id=${obj.emp_id}&emp_name=${obj.emp_name}&emp_domain=${obj.domain}&mode=View`}
                                            >
                                                Offboarding
                                            </a>
                                        </li>
                                    </ul>

                                    {/* <ul class="dropdown-menu shadow border-0" aria-labelledby="dropdownMenuButton1">
  {role != 'Hr' && reportingEmpIds.some((emp) => emp.emp_id == obj.emp_id) ? (
    <li><a class="dropdown-item  semibold-text border-bottom py-2 font-12 directory-feedback" href="#">Add Feedback</a></li>) : null}
    <li><a class="dropdown-item  semibold-text  py-2 font-12 directory-feedback" href={`/offboardingForm?emp_id=${obj.emp_id}&emp_name=${obj.emp_name}&emp_domain=${obj.domain}&mode=View`}> Offboarding</a></li>
  </ul> */}
                                </div>

                            </td>
                        </tr>
                    );
                });
            }
        } catch (e) { }
    };
    /***
     * PC_TD_12 this function set the employee in to the EmpId state variable
     */
    const FeedbackClicked = (EmployeeID, EmpName, EmpDomain) => {
        setEmpId(EmployeeID);
        setEmpName(EmpName);
        setEmpDomain(EmpDomain);
        setHideFeedbackForm(false);
    };
    /***
     * PC_TD_22
     * this function set the column name and sort order into the object
     * and call the loadGrid function.
     */
    const sortClicked = (e) => {
        try {
            let sortID = e.target.id;
            let sortval = sortID.split('@');
            setColumnName(sortval[0]);
            setColumnOrder(sortval[1]);
            setsorthide(sortID);
            setSearchValue('');
        } catch (e) { }
    };
    /**
     * PC_TD_13
     * handelsearch function set the value into the searchvalue statevariable
     * and call the loadTeamDirectoryGridPage function to get the data
     */
    const handleSearch = (e) => {
        try {
            setSearchValue(e.target.value);
        } catch (e) { }
    };
    /**
     * PC_TD_13
     * handelSearchKeyDowm function call the loadTeamDirectoryGridPage while user click enter
     */
    const handleSearchKeyDown = (e) => {
        if (e.charCode == 13) {
            loadTeamDirectoryGridPage();
        }
    };
    /**
     * PC_TD_13
     * search click function call the loadTeamDirectoryGridPage when user clicks the search icon
     */
    const searchClick = () => {
        loadTeamDirectoryGridPage();
    };
    /***
     * PC_TD_13 this function increment the page count base on click
     */
    const handleLoadMore = () => {
        try {
            setCoutPerPage(countPerPage + 10);
        } catch (e) { }
    };

    const handleExportExcel = async () => {
        //debugger
    
        try {
          //debugger;
          let exportToExcel = [
            [
              "Employee Name",
              "Domain",
              "Role",
              "Email",
              "Phone Number",
              "Last Revision Date",
              "status",
              "Rating",
              "CTC"
            ],
          ];
    
    
          for (var i = 0; i < gridData.length; i++) {
            let val= [];
            val.push(
                gridData[i].emp_name,
                gridData[i].domain,
                gridData[i].role,
                gridData[i].email_id,
                gridData[i].phone_num,
                gridData[i].last_revision_date,
                gridData[i].status,
                gridData[i].grand_rating,
                gridData[i].ctc
            );
            exportToExcel.push(val);
          }
    
          let filename ="Team Directory"
          const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
          const fileExtension = '.xlsx';
          let ws = XLSX.utils.aoa_to_sheet(exportToExcel);
          // const exportToCSV = (csvData, fileName) => {
          // const ws = XLSX.utils.(csvData);
          const wb = { Sheets: { 'View Log': ws }, SheetNames: ['View Log'] };
          const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
          const data1 = new Blob([excelBuffer], { type: fileType });
          ////debugger
          FileSaver.saveAs(data1, filename + fileExtension);
          setIsLoading(true);
        } catch (error) {
          throw error;
        }
      };


    return (
        <div className="container-fluid mt-5">
            <Loader isLoading={isLoading} />
            <div className="row justify-content-center ">
                <ReactTooltip />

                <div
                    className="position-fixed col-md-12 mt-3 position-toast d-flex justify-content-center end-0 p-3"
                    style={{ zIndex: 11 }}
                >
                    <div
                        id="liveToast"
                        className="toast side-toast show"
                        role="alert"
                        aria-live="assertive"
                        aria-atomic="true"
                        hidden={hideToast}
                    >
                        <div className="col-md-12 p-2 float-start">
                            <div className>
                                <div className="toast-header border-toast">
                                    <img className="tick px-2 float-start" src="/Images/green-tick.svg" alt="toast" />
                                    <div className="float-start px-3 pe-3">
                                        <div className="bold-text font-18 toast-font-black">Raised Successfully</div>
                                        <div className="body-toast semibold-text font-12 toast-font-grey ">Flag Raised successfully</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-md-11" style={{ marginTop: '10px' }}>
                    <BreadCrumbs data={breadCrumbsData} />
                </div>
                <div className="col-md-11 d-flex justify-content-between my-4  align-items-center">
                    <label className="tt-bold font-15 ">Team Directory -{totalCount || 'N/A'}</label>
                    <div className="d-flex">
                  
                        <div className="input-group flex-nowrap search-group me-2">
                            <input
                                type="search"
                                className="form-control search-align "
                                placeholder="Search by Team Member"
                                aria-label="Username"
                                aria-describedby="addon-wrapping"
                                onKeyPress={(e) => handleSearchKeyDown(e)}
                                onChange={(e) => handleSearch(e)}
                            />
                            <button
                                className="input-group-text btn btn-search-custom "
                                id="addon-wrapping"
                                name="emp_name@Desc"
                                onClick={() => searchClick()}
                            >
                                <img src="/Images/search-icon.svg" alt="search-icon" />
                            </button>
                        </div>
                        <div className="dropdown">
                            <button
                                className="advanced-filter-button me2 medium-text"
                                type="button"
                                id="feedback-filter-dropdown"
                                data-bs-toggle="dropdown"
                                onClick={() => filterClicked()}
                            >
                                <img src="/Images/filter-icon.svg" className="me-2" />
                                Filter
                            </button>
                            {!hideFilterPopUp ? (
                                <div className="dropdown-menu px-3 advanced-filter-panel" style={{ display: 'block' }}>
                                    <div className="row">
                                        <div className="col-md-12 py-2 border-0 mb-1">
                                            <span className="font-16 semibold-text advanced-filter-title">Advanced Filter</span>
                                            <button
                                                type="button"
                                                className="btn-close float-end close-filter"
                                                data-bs-dismiss="advanced-filter"
                                                aria-label="Close"
                                                onClick={() => filterClicked()}
                                            />
                                        </div>
                                        <div className="col-md-12 ">
                                            <div className="row mb-3">
                                                {role != 'Manager' ? (
                                                    <div className="col-md-6 mb-3">
                                                        <label className="form-label hive-form-label" htmlFor="domain-status">
                                                            Domain
                                                        </label>
                                                        <select
                                                            className="form-select hive-form-control"
                                                            id="domain-status"
                                                            name="domain"
                                                            value={filterData.domain}
                                                            onChange={(e) => {
                                                                OnChangeName(e);
                                                            }}
                                                        >
                                                            {/* PC_TD_30 buildDomain() function bind the data into the dropdown */}
                                                            <option value="">Select</option>
                                                            {buildDomain()}
                                                        </select>
                                                    </div>
                                                ) : null}
                                                {/* <div className="col-md-6 mb-3">
                                                    <label className="form-label hive-form-label" htmlFor="leave-type">
                                                        CTC
                                                    </label>
                                                    <select
                                                        className="form-select hive-form-control"
                                                        id="leave-type"
                                                        name="ctc"
                                                        value={filterData.ctc}
                                                        onChange={(e) => {
                                                            OnChangeName(e);
                                                        }}
                                                    >
                                                        PC_TD_30 buildCtc() function bind the data into the dropdown
                                                        <option value="">Select</option>
                                                        {buildCtc()}
                                                    </select>
                                                </div> */}
                                                <div className="col-md-6 mb-3">
                                                    <label className="form-label hive-form-label" htmlFor="leave-type">
                                                        Group
                                                    </label>
                                                    <select
                                                        className="form-select hive-form-control"
                                                        id="leave-type"
                                                        name="grandRating"
                                                        value={filterData.grandRating}
                                                        onChange={(e) => {
                                                            OnChangeName(e);
                                                        }}
                                                    >
                                                        {/* PC_TD_30 buildGroup() function bind the data into the dropdown */}
                                                        <option value="">Select</option>
                                                        {buildGroup()}
                                                    </select>
                                                </div>
                                                <div className="col-md-6 mb-3">
                                                    <label className="form-label hive-form-label" htmlFor="leave-type">
                                                        Status
                                                    </label>
                                                    <select
                                                        className="form-select hive-form-control"
                                                        id="leave-type"
                                                        name="status"
                                                        value={filterData.status}
                                                        onChange={(e) => {
                                                            OnChangeName(e);
                                                        }}
                                                    >
                                                        {/* PC_TD_30 buildStatus() function bind the data into the dropdown */}
                                                        <option value="">Select</option>
                                                        {/* <option value="Active">Active</option>
                                                    <option value="Inactive">Inactive</option> */}
                                                        {buildStatus()}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-12 pb-2 border-0 ">
                                                <span className="font-14 semibold-text filter-title">Date Range - joined Date</span>
                                            </div>
                                            <div className="row mb-3">
                                                <div className="col-md-6 mb-3">
                                                    <label className="form-label hive-form-label" htmlFor="fromrange">
                                                        From
                                                    </label>
                                                    <input
                                                        type="date"
                                                        className="form-control hive-form-control"
                                                        id="fromrange"
                                                        name="startDate"
                                                        value={filterData.startDate}
                                                        max={filterData.endDate}
                                                        onChange={(e) => {
                                                            OnChangeName(e);
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-md-6 mb-3">
                                                    <label className="form-label hive-form-label" htmlFor="torange">
                                                        To
                                                    </label>
                                                    <input
                                                        type="date"
                                                        className="form-control hive-form-control"
                                                        id="torange"
                                                        name="endDate"
                                                        value={filterData.endDate}
                                                        min={filterData.startDate}
                                                        onChange={(e) => {
                                                            OnChangeName(e);
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12 my-3 d-flex justify-content-end">
                                            <button className="btn hive-btn-secondary" onClick={() => filterClearClicked()}>
                                                Clear
                                            </button>
                                            <button className="btn hive-btn-primary" onClick={() => loadTeamDirectoryGridPage()}>
                                                Apply
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ) : null}
                        </div>
                      
                        <button 
                                        className="btn hive-btn-primary d-inline font-14 font-medium px-4 mx-2"
                                        type="button" 
                                        id="dropdownMenuButton1" 
                                        data-bs-toggle="dropdown" 
                                        aria-expanded="false"
                                         onClick={(e)=> handleExportExcel(e)}
                                        >
                                            Export to Excel
                                        </button>
                                    
                    </div>
                </div>
                <div className="col-md-11">
                    <div className="table-responsive table-overflow-visible">
                        <table className="table bg-white hive-grid table-borderless">
                            <thead className="hive-table-head">
                                <tr>
                                    <th className="bold-text font-12">
                                        Employee Name
                                        <span className="ps-2">
                                            <img
                                                src="/Images/Sort-up.svg"
                                                className="hive-table-sort"
                                                id="emp_name@ASC"
                                                onClick={(e) => sortClicked(e)}
                                                hidden={sorthide == 'emp_name@ASC' || '' ? true : false}
                                            />
                                            <img
                                                src="/Images/sort-icon.svg"
                                                className="hive-table-sort"
                                                id="emp_name@DESC"
                                                onClick={(e) => sortClicked(e)}
                                                hidden={sorthide == 'emp_name@ASC' ? false : true}
                                            />
                                        </span>
                                    </th>
                                    {/* {role != 'Manager' ? (
                                        <th className="bold-text font-12">
                                            Domain
                                            <span className="ps-2">
                                                <img
                                                    src="/Images/sort-icon.svg"
                                                    className="hive-table-sort"
                                                    id="domain@DESC"
                                                    onClick={(e) => sortClicked(e)}
                                                    hidden={sorthide == 'domain@DESC' ? true : false}
                                                />
                                                <img
                                                    src="/Images/Sort-up.svg"
                                                    className="hive-table-sort"
                                                    id="domain@ASC"
                                                    onClick={(e) => sortClicked(e)}
                                                    hidden={sorthide == 'domain@DESC' ? false : true}
                                                />
                                            </span>
                                        </th>
                                    ) : null} */}
                                    <th className="text-center bold-text font-12">
                                        Rating
                                        <span className="ps-2">
                                            <img
                                                src="/Images/sort-icon.svg"
                                                className="hive-table-sort"
                                                id="grand_rating@DESC"
                                                onClick={(e) => sortClicked(e)}
                                                hidden={sorthide == 'grand_rating@DESC' ? true : false}
                                            />
                                            <img
                                                src="/Images/Sort-up.svg"
                                                className="hive-table-sort"
                                                id="grand_rating@ASC"
                                                onClick={(e) => sortClicked(e)}
                                                hidden={sorthide == 'grand_rating@DESC' ? false : true}
                                            />
                                            <img
                                                src="/Images/info-icon.svg"
                                                onClick={() => {
                                                    ;
                                                    setpopup(true);
                                                }}
                                                alt="info-icon"
                                                className="ms-2"

                                            />
                                        </span>
                                    </th>
                                    {/* <th className="bold-text font-12">
                                        Status
                                        <span className="ps-2">
                                            <img
                                                src="/Images/sort-icon.svg"
                                                className="hive-table-sort"
                                                id="status@DESC"
                                                onClick={(e) => sortClicked(e)}
                                                hidden={sorthide == 'status@DESC' ? true : false}
                                            />
                                            <img
                                                src="/Images/Sort-up.svg"
                                                className="hive-table-sort"
                                                id="status@ASC"
                                                onClick={(e) => sortClicked(e)}
                                                hidden={sorthide == 'status@DESC' ? false : true}
                                            />
                                        </span>
                                    </th> */}
                                    <th className="bold-text font-12 text-end">
                                        CTC
                                        <span className="ps-2">
                                            <img
                                                src="/Images/sort-icon.svg"
                                                className="hive-table-sort"
                                                id="ctc@DESC"
                                                onClick={(e) => sortClicked(e)}
                                                hidden={sorthide == 'ctc@DESC' ? true : false}
                                            />
                                            <img
                                                src="/Images/Sort-up.svg"
                                                className="hive-table-sort"
                                                id="ctc@ASC"
                                                onClick={(e) => sortClicked(e)}
                                                hidden={sorthide == 'ctc@DESC' ? false : true}
                                            />
                                        </span>
                                    </th>
                                    <th className="bold-text font-12">
                                        Last Revision Date
                                        {/* <span className="ps-2">
                                            <img
                                                src="/Images/sort-icon.svg"
                                                className="hive-table-sort"
                                                id="ctc@DESC"
                                                onClick={(e) => sortClicked(e)}
                                                hidden={sorthide == 'ctc@DESC' ? true : false}
                                            />
                                            <img
                                                src="/Images/Sort-up.svg"
                                                className="hive-table-sort"
                                                id="ctc@ASC"
                                                onClick={(e) => sortClicked(e)}
                                                hidden={sorthide == 'ctc@DESC' ? false : true}
                                            />
                                        </span> */}
                                    </th>                                    
                                    <th className="bold-text font-12">
                                        Date of Joining
                                        <span className="ps-2">
                                            <img
                                                src="/Images/sort-icon.svg"
                                                className="hive-table-sort"
                                                id="joined_date@DESC"
                                                onClick={(e) => sortClicked(e)}
                                                hidden={sorthide == 'joined_date@DESC' ? true : false}
                                            />
                                            <img
                                                src="/Images/Sort-up.svg"
                                                className="hive-table-sort"
                                                id="joined_date@ASC"
                                                onClick={(e) => sortClicked(e)}
                                                hidden={sorthide == 'joined_date@DESC' ? false : true}
                                            />
                                        </span>
                                    </th>
                                    {/* <th className="bold-text font-12">Email ID</th> */}
                                    <th className="bold-text font-12">SLA Period</th>
                                    <th className="bold-text font-12">Phone Number</th>

                                    <th className="text-center bold-text font-12 text-center">Feedbacks</th>

                                    <th className="text-center bold-text font-12"> </th>
                                </tr>
                            </thead>
                            {/* PC_TD_30 teamDirectoryBodyData() function bind the data into teh grid */}
                            <tbody>{teamDirectoryBodyData()}</tbody>
                        </table>
                    </div>
                    {dataLength > countPerPage && isFromDashboard == false ? (
                        <div className="text-center mb-3">
                            <button className="btn show-more-btn" onClick={() => handleLoadMore()}>
                                Show More
                            </button>
                        </div>
                    ) : null}

                    {dataLength >= countPerPage && isFromDashboard == true ? (
                        <div className="text-center mb-3">
                            <button className="btn show-more-btn" onClick={() => handleLoadMore()}>
                                Show More
                            </button>
                        </div>
                    ) : null}
                </div>

                {popup ? (
                    <div className="popup">
                        <div className="popup-content" style={{ width: '1000px', height: '500px', textAlign: 'left' }}>
                            {/* <button className="close-icon"
                                onClick={() => {
                                    setpopup(false)
                                }}>&times;</button> */}

                            {/* <img
                            className="close-icon"
                            src="path/to/close-icon.png" // Replace with the actual path to your image
                            alt="Close"
                            onClick={() => {setpopup(false)}}
                            /> */}

                            <button
                                type="button"
                                className="btn-close float-end close-filter"
                                data-bs-dismiss="advanced-filter"
                                aria-label="Close"
                                onClick={() => {
                                    setpopup(false);
                                }}
                            />

                            <p className="directory-domain-style">
                                <div>
                                    <label class="tt-bold font-15 ">Ratings Description</label>
                                </div>
                                <div style={{ display: 'flex' }} className="mt-3 rating_space">
                                    {' '}
                                    <span>
                                        <img src={`/Images/A_plus.png`} alt="A+" className="directory-emoji-class" />
                                        <span className="ms-2 font-16 tt-bold">A+ </span>
                                        <span>
                                            Team members who are in line with the organization and we can groom the resources for next level
                                            leadership.
                                        </span>
                                    </span>
                                </div>
                                <div style={{ display: 'flex' }} className="rating_space">
                                    {' '}
                                    <span>
                                        <img src={`/Images/A_minus.png`} alt="A-" className="directory-emoji-class" />
                                        <span className="ms-2 font-16 tt-bold">A- </span>
                                        <span>
                                            Team members who have clear understanding on Technology, Business and communicate the gaps, also
                                            deliver the project. But still are not taking ownership & are on path to next level.
                                        </span>
                                    </span>
                                </div>
                                <div style={{ display: 'flex' }} className="rating_space">
                                    {' '}
                                    <span>
                                        <img src={`/Images/B_plus.png`} alt="B+" className="directory-emoji-class" />
                                        <span className="ms-2 font-16 tt-bold">B+ </span>
                                        <span>
                                            They have gaps in understanding the business and tech but are able to clearly communicate the
                                            gaps and get doubts rectified and progress
                                        </span>
                                    </span>
                                </div>
                                <div style={{ display: 'flex' }} className="rating_space">
                                    {' '}
                                    <span>
                                        <img src={`/Images/B_minus.png`} alt="B-" className="directory-emoji-class" />
                                        <span className="ms-2 font-16 tt-bold">B- </span>
                                        <span>
                                            They lack in business and tech understanding but communicate the issues and show intention to
                                            progress
                                        </span>
                                    </span>
                                </div>
                                <div style={{ display: 'flex' }} className="rating_space">
                                    {' '}
                                    <span>
                                        <img src={`/Images/C_plus.png`} alt="C+" className="directory-emoji-class" />
                                        <span className="ms-2 font-16 tt-bold">C+ </span>
                                        <span>
                                            Members who would be able to work but show no intention of working-attitude/performance issues
                                            (Probably PIP scenarios).
                                        </span>
                                    </span>
                                </div>
                                <div style={{ display: 'flex' }} className="rating_space">
                                    {' '}
                                    <span>
                                        <img src={`/Images/C_minus.png`} alt="C-" className="directory-emoji-class" />
                                        <span className="ms-2 font-16 tt-bold">C- </span>
                                        <span>
                                            Clearly out - people who have no business and tech understanding and not aligned with our
                                            principles / even after multiple feedbacks there is no progress
                                        </span>
                                    </span>
                                </div>
                            </p>
                        </div>
                    </div>
                ) : (
                    <></>
                )}

                <div
                    className="tab-pane fade show active"
                    id="my_leave_request"
                    role="tabpanel"
                    aria-labelledby="my_leave_request_tab"
                ></div>
                <div className="tab-pane fade show active" id="wfh_request" role="tabpanel" aria-labelledby="wfh_request_tab"></div>
                <div className="tab-pane fade show active" id="my_wfh_request" role="tabpanel" aria-labelledby="my_wfh_request_tab"></div>
            </div>
            {/* PC_TD_12 AddFeedback function is called from AddFeedbackForm  */}
            <AddFeedback
                empId={empId}
                empName={empName}
                empDomain={empDomain}
                setHideToast={() => setHideToast()}
                ReloadGridPage={null}
                hideFeedbackForm={hideFeedbackForm}
                setHideFeedbackForm={() => setHideFeedbackForm()}
            />
        </div>
    );
}

export default TeamDirectory;
